// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"51fe9522","455":"ca6184f0","977":"8303e35f"}[chunkId] + ".chunk.js";
};